var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar',{attrs:{"initials":_vm.initials,"value":_vm.user.email,"smaller":_vm.smaller}})}
var staticRenderFns = []

export { render, staticRenderFns }